import { BookEnum } from '@interfaces/BookEnum'
import { Exclude, Expose, Transform, Type } from 'class-transformer'

export class MyEbookListType {
  @Expose() id: number

  @Expose() coverImgPath?: string

  @Expose() title: string

  @Expose() bookType: BookEnum

  @Expose()
  @Transform(({ value }) => value || 0)
  totalEbookSeries: number

  @Expose()
  @Transform(({ value }) => value || 0)
  avgEbookRating: number

  @Expose()
  @Transform(({ value }) => value || 0)
  totalEbookReview: number

  @Expose()
  @Transform(({ value }) => value || 0)
  totalEbookWishlist: number

  @Expose()
  @Transform(({ value }) => value || 0)
  totalEbookPurchaseCount: number
}

@Exclude()
export class MyEbookResponse {
  @Expose()
  @Type(() => MyEbookListType)
  data: MyEbookListType[]

  @Expose()
  total: number

  @Expose()
  page: number
}
